import { render, staticRenderFns } from "./TenantSubscriptionStatus.vue?vue&type=template&id=35087a9c"
import script from "./TenantSubscriptionStatus.vue?vue&type=script&lang=js"
export * from "./TenantSubscriptionStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports